/**
 * Skeleton: sand.100 → sand.200 shimmer, radius sm. Use TableSkeleton / StatSkeleton from src/components/ui for real layouts.
 * Chakra only reads variant/size/colorScheme from theme defaultProps, so the 1.2s shimmer is passed as `speed={1.2}`
 * at each call site instead of here.
 */
export const Skeleton = {
  baseStyle: {
    borderRadius: "sm",
    "--skeleton-start-color": "#F3F1EB",
    "--skeleton-end-color": "#E8E5DC",
    opacity: 1,
  },
};
